<template>
  <div class="container">
    <div class="picker-item" v-for="(item, index) in pickerData" :key="index" @click="operation(item)">
      <span :class="['iconfont', item.icon]" />
      <span class="text">{{ item.text }}</span>
    </div>
    <div class="cancel" @click="close">
      取消
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationPicker",
  props: {
    pickerData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    operation(obj) {
      this.$emit('operation', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: auto;
  min-height: 200px;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  box-sizing: border-box;
  padding: 12px 0 0;
  .picker-item {
    width: 100%;
    height: 44px;
    padding: 0 26px;
    font-size: 14px;
    color: #404040;
    border-bottom: 1px solid #f9f9f9;
    line-height: 44px;
    .text {
      margin-left: 14px;
    }
  }
  .cancel {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #404040;
  }
}
</style>
